import React from "react";
import { Switch, Route } from "react-router-dom";

import RouteEnum from "./RouteEnum";
import { FrameContext } from "../contexts/FrameContext";
import AgentProfile from "../components/agents/AgentProfile";
import EditAgent from "../components/agents/EditAgent";
import LocationProfile from "../components/locations/LocationProfile";
import EditLocation from "../components/locations/EditLocation";
import Home from "../components/home/Home";
import LocationSchedule from "../components/locations/LocationSchedule";
import AgentSchedule from "../components/agents/AgentSchedule";
import Header from "../components/common/Header";
import AppointmentCancel from "../components/appointments/AppointmentCancel";
import AppointmentConfirm from "../components/appointments/AppointmentConfirm";
import AppointmentReschedule from "../components/appointments/AppointmentReschedule";
import AppointmentJoin from "../components/appointments/AppointmentJoin";
import EditAppointment from "../components/appointments/EditAppointment";


const Router = () => {
    const { companyId, sendMessage, isInFrame } = React.useContext(FrameContext);

    React.useEffect(() => {
        sendMessage("scheduling_ready");
    }, [])

    if (!companyId) return null;

    return (
        <>
            <div style={{ marginTop: 0, paddingTop: 0, height: "1px" }}></div>
            {/* {!isInFrame() && <Header />} */}
            <Switch>
                <Route exact={true} path={RouteEnum.HOME} component={Home} />
                <Route exact={true} path={RouteEnum.LOCATION} component={LocationProfile} />
                <Route exact={true} path={RouteEnum.LOCATION_PROFILE} component={EditLocation} />
                <Route exact={true} path={RouteEnum.LOCATION_SCHEDULE} component={LocationSchedule} />
                <Route exact={true} path={RouteEnum.AGENT} component={AgentProfile} />
                <Route exact={true} path={RouteEnum.AGENT_PROFILE} component={EditAgent} />
                <Route exact={true} path={RouteEnum.AGENT_SCHEDULE} component={AgentSchedule} />
                <Route exact={true} path={RouteEnum.APPOINTMENT_EDIT} component={EditAppointment} />
                <Route exact={true} path={RouteEnum.APPOINTMENT_CONFIRM} component={AppointmentConfirm} />
                <Route exact={true} path={RouteEnum.APPOINTMENT_CANCEL} component={AppointmentCancel} />
                <Route exact={true} path={RouteEnum.APPOINTMENT_RESCHEDULE} component={AppointmentReschedule} />
                <Route exact={true} path={RouteEnum.APPOINTMENT_JOIN} component={AppointmentJoin} />
            </Switch>
        </>
    )
};

export default Router;